<template>
  <v-dialog v-model="internalValue" max-width="400">
    <v-card class="pa-4 text-center" rounded="lg">
      <v-card-title class="headline font-weight-bold justify-center">發送失敗</v-card-title>
      <v-card-text>
        <div class="red-6--text mb-7" v-html="message" />
        <div class="d-flex flex-column" style="row-gap: 20px;">
          <template v-for="(btn, index) in buttons">
            <v-btn
              :key="index"
              :color="btn.color || 'primary'"
              :href="btn.href"
              :outlined="btn.outlined"
              :block="true"
              v-bind="btn.options"
              @click="handleClick(btn)"
            >
              {{ btn.text }}
            </v-btn>
          </template>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'SendFailDialog',
  props: {
    value: { type: Boolean, required: true },
    message: { type: String, required: true },
    buttons: { type: Array, required: true },
  },
  computed: {
    internalValue: {
      get() { return this.value },
      set(val) { this.$emit('input', val) }
    }
  },
  methods: {
    handleClick(btn) {
      if (!btn.href && btn.close !== false) {
        this.internalValue = false
      }
      if (typeof btn.onClick === 'function') {
        btn.onClick()
      }
    }
  }
}
</script>

<style scoped>
</style>
